// 请求数据的service
import axios from 'axios'
import qs from 'qs'
import * as common from '../utils/common' // 公共方法

import './element'
import router from '../router/index'

const netWork = 'internet' // internet : 互联网
// const netWork = 'intranet'; // intranet : 公安网
// const baseURL = '/aos-test'
// const baseURL = '/aos'
const baseURL = '/acms'

export { get, post, formData, formUrlencoded, get3, post3, netWork, baseURL }
window._axiosPromiseArr = []

axios.defaults.withCredentials = true
axios.defaults.crossDomain = true

/**
 * http: application/json 格式
 */
const http = axios.create({
  headers: {
    'Content-Type': 'application/json'
    // token: common.session.get('token') ? common.session.get('token') : ''
  }
})
http.defaults.timeout = '60000'
http.defaults.baseURL = baseURL

const http2 = axios.create({
  baseURL: '/acms',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    token: common.session.get('token') ? common.session.get('token') : ''
  }
})

/**
 * http: application/json 格式
 */
const http3 = axios.create({
  headers: {
    'Content-Type': 'application/json'
    // token: common.session.get('token') ? common.session.get('token') : ''
  }
})
http3.defaults.timeout = '60000'
http3.defaults.baseURL = baseURL

// http request 拦截器
http.interceptors.request.use(
  config => {
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      config.data = qs.stringify(config.data)
    }
    if (config.headers['Content-Type'] === 'application/json') {
      config.data = JSON.stringify(config.data)
    }
    if (config.url === '/case/queryShareCase' || config.url === 'case/fillInTheShareCase') {
      config.headers.token = common.session.get('token') ? common.session.get('token') : ''
    } else {
      config.headers.token = common.session.get('token') ? common.session.get('token') : ''
    }
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel })
    })
    return config
  },
  error => {
    console.log(
      '%c http返回：\n ' + timeFormat('yyyy-MM-dd hh:mm:ss', new Date()),
      'font-weight: bold; color:#fff; background:#F56C6C; padding: 4px 2px;',
      ' \n' + JSON.parse(JSON.stringify(error))
    )
    return Promise.reject(error)
  }
)

// http response 拦截器
http.interceptors.response.use(
  response => {
    if (response.headers.token) {
      common.session.set('token', response.headers.token)
    }
    if (response.data.status === -9) {
      const urls = [
        '/case/queryShareCase',
        '/case/fillInTheShareCase',
        '/case/queryShareCaseShareholder',
        '/case/addShareCaseShareholder',
        '/case/deleteShareCaseShareholder',
        '/pic/upload'
      ]
      if (urls.indexOf(response.config.url) >= 0) {
      } else {
        if (window.location.pathname !== '/') {
          router.push('/')
        }
      }
    }
    return response
  },
  error => {
    console.log(
      '%c http返回：\n ' + timeFormat('yyyy-MM-dd hh:mm:ss', new Date()),
      'font-weight: bold; color:#fff; background:#F56C6C; padding: 4px 2px;',
      '\n',
      JSON.parse(JSON.stringify(error))
    )
    if (error.message.includes('timeout')) {
      // 判断请求异常信息中是否含有超时timeout字符串
      error.message = '网络请求超时，请重试！'
      return Promise.reject(error) // reject这个错误信息
    } else if (error.message.includes('Network')) {
      error.message = '网络连接失败，请重试！'
      return Promise.reject(error) // reject这个错误信息
    } else {
      return Promise.reject(error)
    }
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
function get3(url, params = {}) {
  return new Promise((resolve, reject) => {
    http3
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        if (err.message === 'cancel') {
          return false
        }
        reject(err)
      })
  })
}
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        if (err.message === 'cancel') {
          return false
        }
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    http.post(url, data).then(
      response => {
        resolve(response.data)
      },
      err => {
        if (err.message === 'cancel') {
          return false
        }
        reject(err)
      }
    )
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
function post3(url, data = {}) {
  return new Promise((resolve, reject) => {
    http3.post(url, data).then(
      response => {
        resolve(response.data)
      },
      err => {
        if (err.message === 'cancel') {
          return false
        }
        reject(err)
      }
    )
  })
}

/**
 * 封装post: form-data请求
 * @param url
 * @param data
 * @returns {Promise}
 */
function formData(url, data) {
  return new Promise((resolve, reject) => {
    http
      .post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(
        response => {
          resolve(response.data)
        },
        err => {
          reject(err)
        }
      )
  })
}

/**
 * 封装post: x-www-form-urlencoded请求
 * @param url
 * @param data
 * @returns {Promise}
 */
function formUrlencoded(url, data = {}) {
  return new Promise((resolve, reject) => {
    http2.post(url, qs.stringify(data)).then(
      response => {
        resolve(response.data)
      },
      err => {
        reject(err)
      }
    )
  })
}

/**
 * 时间戳转化为年 月 日 时 分 秒
 * date: 传入时间对象
 * format：返回格式，支持自定义
 */
function timeFormat(format, date) {
  // 日期解析
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}
